import * as Components from './components';
import * as Containers from './containers';
import * as Routes from './routes';

export default {
    Components,
    Containers,
    Routes
}